import {
    GET_POE_SETTINGS,
    GET_POE_SETTINGS_SUCCESS,
    GET_POE_SETTINGS_FAIL,

} from '../../constants/switchConfiguration/poeSettingsConstants.js';

/**
 * Reducer function for managing basic Settings data state.
 *
 * This reducer handles actions related to fetching basic Settings data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the basic Settings.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const poeSettingsReducer = (state = { settingsData: {} }, action) => {
    switch (action.type) {
        case GET_POE_SETTINGS:
            return {
                loading: true,
            };
        case GET_POE_SETTINGS_SUCCESS:
            return {
                loading: false,
                settingsData: action.payload,
            };
        case GET_POE_SETTINGS_FAIL:
            return {
                loading: false,
                error: action.payload,
            };
            
        default:
            return state;
    }
};

